import axios from 'axios';

const sendMessage = async (content: any) => {
  await axios.post(`/api/message`, { content });
};

export default {
  sendMessage
};
